import { render } from "./EditQuestionView.vue?vue&type=template&id=2be2957d&scoped=true"
import script from "./EditQuestionView.vue?vue&type=script&lang=js"
export * from "./EditQuestionView.vue?vue&type=script&lang=js"

import "./EditQuestionView.vue?vue&type=style&index=0&id=2be2957d&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be2957d"]])

export default __exports__